import user from "./images/user.jpg"


export const reviews = [{
    img: user,
    name: 'winnie',
    description: 'Absolutely love my new stickers! The quality is fantastic, and they shipped super fast. I’ll definitely be ordering more!',
    ratings: '★★★★★'
},{
    img: user,
    name: 'John',
    description: 'The holographic stickers are amazing! They stick perfectly on my phone case, and I’ve already gotten so many compliments.',
    ratings: '★★★★★'
},{
    img: user,
    name: 'Anita Jepkoech',
    description: 'I ordered custom stickers, and they turned out exactly how I imagined. The detail is incredible.',
    ratings: '★★★★★'
},{
    img: user,
    name: 'Nickson Kipkorir',
    description: 'I ordered custom stickers, and they turned out exactly how I imagined. The detail is incredible. Highly recommend this shop!',
    ratings: 'I ordered custom stickers, and they turned out exactly how I imagined. The detail is incredible.'
}]